module.exports = __webpack_public_path__ + "static/img/Consulting03.700e1afe.png";